// Dropdown options for consultation submissions
export const CONSULTATION_OPTIONS = {
  quality: [
    { value: 'Qualified', label: 'Qualified', color: 'success' },
    { value: 'Not Qualified', label: 'Not Qualified', color: 'error' }
  ],
  status: [
    { value: 'No Answer', label: 'No Answer', color: 'warning' },
    { value: 'Not Interested', label: 'Not Interested', color: 'error' },
    { value: 'Contacted', label: 'Contacted', color: 'info' }
  ],
  membership: [
    { value: '', label: 'None', color: 'default' },
    { value: 'Tier1', label: 'Tier 1', color: 'info' },
    { value: 'Tier2', label: 'Tier 2', color: 'warning' },
    { value: 'Tier3', label: 'Tier 3', color: 'success' }
  ],
  // followup is now a free text field, not a dropdown
  campaign: [
    { value: 'Website Form', label: 'Website Form', color: 'primary' },
    { value: 'Their friend', label: 'Their Friend', color: 'info' },
    { value: 'you', label: 'You', color: 'secondary' }
  ]
};

// Color mapping for status indicators
export const STATUS_COLORS = {
  'Qualified': 'success',
  'Not Qualified': 'error',
  'Contacted': 'info',
  'No Answer': 'warning',
  'Not Interested': 'error'
};

// Default values for new consultations
export const DEFAULT_CONSULTATION = {
  quality: 'Qualified',
  status: 'No Answer',
  membership: '',
  followup: '',
  which_campaign: 'Website Form'
};

// Table column configuration
export const CONSULTATION_COLUMNS = [
  {
    field: 'date',
    headerName: 'Date',
    width: 120,
    type: 'date',
    sortable: true,
    valueFormatter: (params) => {
      return new Date(params.value).toLocaleDateString();
    }
  },
  {
    field: 'name',
    headerName: 'Name',
    width: 120,
    sortable: true
  },
  {
    field: 'last_name',
    headerName: 'Last Name',
    width: 120,
    sortable: true
  },
  {
    field: 'phone',
    headerName: 'Phone',
    width: 140,
    sortable: false,
    renderCell: (params) => {
      return `tel:${params.value}`;
    }
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 200,
    sortable: true,
    renderCell: (params) => {
      return `mailto:${params.value}`;
    }
  },
  {
    field: 'quality',
    headerName: 'Quality',
    width: 120,
    editable: true,
    type: 'singleSelect',
    valueOptions: CONSULTATION_OPTIONS.quality.map(option => option.value)
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 140,
    editable: true,
    type: 'singleSelect',
    valueOptions: CONSULTATION_OPTIONS.status.map(option => option.value)
  },
  {
    field: 'membership',
    headerName: 'Membership',
    width: 120,
    editable: true,
    type: 'singleSelect',
    valueOptions: CONSULTATION_OPTIONS.membership.map(option => option.value)
  },
  {
    field: 'followup',
    headerName: 'Followup',
    width: 250,
    editable: true,
    type: 'string',
    sortable: true
  },
  {
    field: 'which_campaign',
    headerName: 'Which Campaign',
    width: 150,
    editable: true,
    type: 'singleSelect',
    valueOptions: CONSULTATION_OPTIONS.campaign.map(option => option.value)
  }
];

// Helper function to get color for a status value
export const getStatusColor = (field, value) => {
  // Followup is a text field, not a dropdown, so no color coding
  if (field === 'followup') {
    return 'default';
  }
  const option = CONSULTATION_OPTIONS[field]?.find(opt => opt.value === value);
  return option?.color || 'default';
};

// Helper function to get label for a status value
export const getStatusLabel = (field, value) => {
  // Followup is a text field, return the value as-is
  if (field === 'followup') {
    return value || '';
  }
  const option = CONSULTATION_OPTIONS[field]?.find(opt => opt.value === value);
  return option?.label || value;
}; 